// ** Reducers Imports
import layout from "./layout";
import navbar from "./navbar";
import user from "./userReducer";

const rootReducer = { navbar, layout, user };

export default rootReducer;
